import React, { CSSProperties, FC, useCallback } from 'react'
import classNames from 'classnames'
import { Hypebot } from '@/organisms/Hypebot'
import { ChatbotMessageType, ChatFeedMessage } from '@/services/WatchPartyChatService'
import { WatchPartyChatContextProvider } from '@/services/WatchPartyChatService/WatchPartyChatService'
import { ChatbotMessageTicketIntent } from '@/services/WatchPartyChatService/types'
import { TheatricalReleaseObject } from '@/types/codegen-federation'
import { useSafeRouter } from '@/utils/nextUtils/safe-router'

interface Props {
  hypebotCode: string
  theatricalRelease: TheatricalReleaseObject
  theatricalSlug: string
  className?: string
  style?: CSSProperties
}
export const TheatricalHypebot: FC<Props> = ({ hypebotCode, theatricalSlug, theatricalRelease, className, style }) => {
  const { query } = useSafeRouter()

  const theater = typeof query?.theater === 'string' ? query.theater.toLowerCase() : null
  const messageFilter = useCallback(
    (message: ChatFeedMessage | ChatbotMessageTicketIntent) => {
      const venue = (message as ChatbotMessageTicketIntent)?.venue_name?.toLowerCase()
      if (!theater || !venue || venue.includes(theater)) return true
      return false
    },
    [theater],
  )

  const acceptedHypeMessages = [
    ChatbotMessageType.claim,
    ChatbotMessageType.ticket,
    ChatbotMessageType.pif,
    ChatbotMessageType.guild,
  ]

  return (
    <div
      style={style}
      className={classNames('w-full flex flex-col overflow-hidden rounded-[16px] md:max-h-none', className)}
    >
      <WatchPartyChatContextProvider
        chatCode={hypebotCode}
        acceptedMessageTypes={acceptedHypeMessages}
        projectSlug={theatricalSlug}
        messageFilter={messageFilter}
      >
        <Hypebot
          initialMessageClassName="text-white"
          isNewDesign={true}
          className="min-h-0 w-full flex-1 overflow-y-auto bg-white/10 text-white"
          theatricalRelease={theatricalRelease}
        />
      </WatchPartyChatContextProvider>
    </div>
  )
}
